export default __webpack_public_path__ + "static/media/object--support--pole.36dfcf46.png";